/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import { pushToSetting } from '../../redux/slices/SettingSclice';
import { setSetting } from '../action/common';
import { GroupIcon, GroupSortIcon, SortIcon, Tick } from '../LandingHeader/Feedback/icons/Icons';

const GroupAndSortByDropdown = React.memo(() => {
    const { settings } = useSelector(state => state.settings)
    const dispatch = useDispatch()
    const groupOptions = [{value: 'none', label: 'List'}, {value: 'project', label: 'Project'}, {value: 'calendar', label: 'Calendar'}]
    const sortOptions = [{value: 'asc', label: 'Ascending', icon: <SortIcon />}, {value: 'desc', label: 'Descending', icon: <SortIcon direction="desc" />}]
    const sortByOptions = [{value: 'title', label: 'Name'}, {value: 'Project.title', label: 'Project'}, {value: 'date', label: 'Do Date', default: true}, {value: 'createdAt', label: 'Date Added'}]
    const [showDropdown, setShowDropdown] = useState(false)

    useEffect(()=>{
        document.addEventListener('click', closeDropdown);

        return () => {
            document.removeEventListener('click', closeDropdown);
        }
    }, [])

    const closeDropdown = (e) => {
        if(!e.target?.closest('.actions-dropdown-container')){
            setShowDropdown(false);
        }
    }
    
    const selectGroupBy = ({value}) => {
        const newSettings = { ...settings, groupBy: value };
        dispatch(pushToSetting(newSettings))
        setSetting({ settings: newSettings });
    }

    const selectSort = ({value}) => {
        const newSettings = { ...settings, sort: value };
        dispatch(pushToSetting(newSettings))
        setSetting({ settings: newSettings });
    }

    const selectSortBy = ({value}) => {
        const newSettings = { ...settings, sortBy: value };
        dispatch(pushToSetting(newSettings))
        setSetting({ settings: newSettings });
    }

    const toggleDropdown = (e) => {
        e.stopPropagation()
        e.preventDefault()
        setShowDropdown(!showDropdown)
    }

    return (
        <div className='actions-dropdown-container flex' css={{
            li: {
                '&:hover': {
                    background: `linear-gradient(0deg, rgba(255,255,255,0.80) 0%,rgba(255,255,255,0.80) 100%),linear-gradient(0deg,var(--accent-color) 0%,var(--accent-color) 100%),#FFF !important`,
                }
            }
        }}>
            <a href="#" className='group-sort-icon' onClick={toggleDropdown}><GroupSortIcon fill={showDropdown ? `var(--accent-color)` : 'none'} /></a>
            {
                showDropdown &&
                <div className="actions-dropdown overflow-visible !top-10 !right-0">
                    <ul>
                        <li className="rounded-[15px_15px_0_0]">
                            <a className='group/action-item action-item relative border-rounded-15-15-0-0' href="javascript: void(0);">
                                <SortIcon />
                                Sort by
                                <span className="flex-1 self-stretch"></span>
                                <span className='accent-text-color'>{settings?.sortBy ? sortByOptions.find(option => option.value === settings?.sortBy)?.label : 'Default'}</span>
                                <div className="actions-dropdown group-hover/action-item:block !top-0 !right-full hidden">
                                    <ul>
                                        {
                                            sortOptions.map((option, index) => (
                                                <li key={index}>
                                                    <a className='action-item border-b-0' href="javascript: void(0);" onClick={() => selectSort(option)}>
                                                        {option.icon}
                                                        {option.label}
                                                        <span className="flex-1 self-stretch"></span>
                                                        {settings?.sort === option.value && <Tick color={`var(--accent-color)`} />}
                                                    </a>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                    <div className='hr-line after:!left-0'></div>
                                    <ul>
                                        {
                                            sortByOptions.map((option, index) => (
                                                <li key={index}>
                                                    <a className='action-item border-b-0' href="javascript: void(0);" onClick={() => selectSortBy(option)}>
                                                        {option.label}
                                                        {option?.default && <span className='default-label opacity-30'>Default</span>}
                                                        <span className="flex-1 self-stretch"></span>
                                                        {(settings?.sortBy || 'date') === option.value && <Tick color={`var(--accent-color)`} />}
                                                    </a>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </a>
                        </li>
                        <li className="rounded-[0_0_15px_15px]">
                            <a className="group/action-item action-item relative border-radius-0-0-15-15" href="javascript: void(0);">
                                <GroupIcon />
                                Group by
                                <span className="flex-1 self-stretch"></span>
                                <span className='accent-text-color'>{settings?.groupBy ? groupOptions.find(option => option.value === settings?.groupBy)?.label : 'List'}</span>
                                <div className="actions-dropdown group-hover/action-item:block !top-0 !right-full hidden">
                                    <ul>
                                        {
                                            groupOptions.map((option, index) => (
                                                <li key={index}>
                                                    <a className='action-item' href="javascript: void(0);" onClick={() => selectGroupBy(option)}>
                                                        {option.label}
                                                        <span className="flex-1 self-stretch"></span>
                                                        {(settings?.groupBy ?? 'none') === option.value && <Tick color={`var(--accent-color)`} />}
                                                    </a>
                                                </li>
                                            ))
                                        }
                                    </ul>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            }
        </div>
    )
})

export default GroupAndSortByDropdown